import {
	HomeOutlined,
	UserOutlined,
	ShopOutlined,
	BookOutlined,
	UsergroupAddOutlined,
	SettingOutlined,
	PlayCircleOutlined,
} from "@ant-design/icons";
import { ProjetoSVG } from "assets/svg/icon";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoConfiguracaoEnum,
	PermissaoPedidoEnum,
	PermissaoGrupoUsuarioEnum,
	PermissaoProjetoEnum,
	PermissaoUsuarioEnum,
	PermissaoLivroEnum,
	PermissaoTreinamentoEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}/dashboard`,
		title: "dashboard",
		icon: HomeOutlined,
		breadcrumb: true,
		submenu: [],
		permissao: [
			PermissaoPedidoEnum.VISUALIZAR,
			PermissaoLivroEnum.VISUALIZAR,
		],
	},
	{
		key: "lista-projetos",
		path: `${APP_PREFIX_PATH}/lista-projetos`,
		title: "lista-projetos",
		icon: ProjetoSVG,
		// breadcrumb: true,
		submenu: [],
		permissao: PermissaoProjetoEnum.VISUALIZAR,
	},
	{
		key: "lista-usuarios",
		path: `${APP_PREFIX_PATH}/lista-usuarios`,
		title: "lista-usuarios",
		icon: UserOutlined,
		// breadcrumb: true,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-grupos-usuario",
		path: `${APP_PREFIX_PATH}/lista-grupos-usuario`,
		title: "lista-grupos-usuario",
		icon: UsergroupAddOutlined,
		submenu: [],
		permissao: PermissaoGrupoUsuarioEnum.VISUALIZAR,
	},
	{
		key: "lista-pedidos",
		path: `${APP_PREFIX_PATH}/lista-pedidos`,
		title: "lista-pedidos",
		icon: ShopOutlined,
		// breadcrumb: true,
		submenu: [],
		permissao: PermissaoPedidoEnum.VISUALIZAR,
	},
	{
		key: "lista-livros",
		path: `${APP_PREFIX_PATH}/lista-livros`,
		title: "lista-livros",
		icon: BookOutlined,
		// breadcrumb: true,
		submenu: [],
		permissao: PermissaoLivroEnum.VISUALIZAR,
	},
	{
		key: "lista-treinamentos",
		path: `${APP_PREFIX_PATH}/lista-treinamentos`,
		title: "lista-treinamentos",
		icon: PlayCircleOutlined,
		submenu: [],
		permissao: PermissaoTreinamentoEnum.VISUALIZAR,
	},
	{
		key: "configuracoes-sistema",
		path: `${APP_PREFIX_PATH}/configuracoes-sistema`,
		title: "configuracoes-sistema",
		icon: SettingOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoConfiguracaoEnum.VISUALIZAR,
	},
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
